import React, {useEffect, useState} from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import "./ModalCreationCompte.scss";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Calendar } from "primereact/calendar";
import DateFnsUtils from "@date-io/date-fns";
import { fr } from "date-fns/locale";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import {
  callAPIAlumni,
  useFetchGet,
  useFetchGetConditional,
} from "Services/api";
import Loader from "Components/Loader/loader";
import ModalCharte from "Components/Modal/ModalCharte/ModalCharte";
import { useTranslation } from "react-i18next";
import { formatDateDatabase } from "Services/functions";
import data from "assets/countries";
import { MultiSelect } from "primereact/multiselect";

const CompteUniversite = (props) => {
  const niveauDiplomeData = useFetchGet(
      "/level_of_educations",
      props.auth.token
  );
  const universitiesData = useFetchGetConditional(
      "/universities",
      null,
      props.universities.universitiesData
  );
  const { t } = useTranslation("common");
  const [visibleModalCharte, setvisibleModalCharte] = useState(false);

  const [componentsGroup, setComponentsGroup] = useState([]);
  const componentsData = useFetchGet("/groups/components");

  // si le formulaire est utilisé au moment de la création de compte on prend des valeurs de base nulles
  // si le formulaire est utilisé au moment de la modification de profil on prend les valeurs de l'utilisateur
  function valeursFinales() {
    if (props.utilisateur == undefined) {
      return defaultValues;
    } else {
      defaultValues.email = props.utilisateur.email;
      return defaultValues;
    }
  }
  const [showMessage, setShowMessage] = useState(false);
  const [formData, setFormData] = useState({});
  const [country, setCountry] = useState("France");

  // constantes de l'utilisateur
  let defaultValues = {
    lastName: "",
    firstName: "",
    universite: "",
    anneeDiplome: "2023",
    niveauDiplome: "",
    country: "France",
    email: "",
    date: null,
    phone: "",
    motivation: "",
    accept: false,
    alumni: true,
    components: [],
  };
  valeursFinales();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    getValues,
  } = useForm({ defaultValues });


  useEffect(() => {
    if (universitiesData?.data?.length) {
      const defaultUni = universitiesData.data.find(u => u.name === "USPN");
      if (defaultUni) {
        setValue("universite", defaultUni);
      }
    }
  }, [universitiesData?.data, setValue]);

    useEffect(() => {
        if (
            componentsData.loaded &&
            componentsData.data &&
            componentsData.data.length > 0
        ) {
            setComponentsGroup(
                componentsData.data
                    .filter((c) => typeof c.componentLabel === "string")
                    .sort((a, b) =>
                        a.componentLabel.localeCompare(b.componentLabel)
                    )
            );
        }
    }, [componentsData.loaded, componentsData.data]);

  const onSubmitCharte = async () => {
    let data = getValues();
    data.accept = true;
    data.date = formatDateDatabase(data.date);
    setFormData(data);
    const body = {
      givenName: data.firstName,
      sn: data.lastName,
      supannOIDCDateDeNaissance: data.date,
      pager: data.phone,
      supannMailPerso: data.email,
      supannConsentement: data.accept,
      motivation: data.motivation,
      country: data.country,
      graduationYear: data.anneeDiplome,
      levelOfEducation: data.niveauDiplome.label,
      components: data.components
    };

    try {
      const res = await callAPIAlumni(
          "/send-email-before-validate-alumni",
          body,
          props.auth.toast
      );

      console.log("final :", res); // ✅ vrai résultat
      setvisibleModalCharte(false);

      if (res.status === 200) {
        setShowMessage(true);
      }

      setTimeout(() => {
        props.setVisibleModal(false);
      }, 2000);

      reset();
    } catch (error) {
      console.log("Erreur attrapée :", error);
    }

  };

  const onSubmit = () => {
    setvisibleModalCharte(true);
  };

  const getFormErrorMessage = (name) => {
    return (
        errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const dialogFooter = (
      <div className="flex justify-content-center">
        <Button
            label="OK"
            className="p-button-text"
            autoFocus
            onClick={() => {
              setShowMessage(false);
              props.setVisibleModal(false);
            }}
        />
      </div>
  );
  return (
      <div className="form-demo">
        <Dialog
            appendTo={document.getElementById("app")}
            visible={showMessage}
            onHide={() => setShowMessage(false)}
            position="top"
            footer={dialogFooter}
            showHeader={false}
            breakpoints={{ "960px": "80vw" }}
            style={{ width: "30vw" }}
        >
          <div className="flex justify-content-center flex-column pt-6 px-3">
            <i
                className="pi pi-check-circle"
                style={{ fontSize: "5rem", color: "var(--green-500)" }}
            ></i>
            <h5>Création de compte terminée !</h5>
            <p style={{ lineHeight: 1.5, textIndent: "1rem" }}>
              Votre compte est enregistré sous le nom de{" "}
              <b>{formData.firstName}</b> <b>{formData.lastName}</b>. Un mail vous
              sera envoyé à <b>{formData.email}</b> une fois votre compte activé.
            </p>
          </div>
        </Dialog>

        <div className="card">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="field">
              <h2>{t("createAccount.intro")}</h2>

              <div className="checkboxes">
                {/* <div className="field checkbox">
                {/* <Controller
                  name="student"
                  control={control}
                  render={({ field }) => (
                    <Checkbox
                      className="checkbox_student"
                      id={field.name}
                      checked={field.value}
                      onChange={(e) => {
                        field.onChange(e.checked);
                        setValue("alumni", !e.checked);
                      }}
                    />
                  )}
                />
                <label htmlFor="student">Etudiant</label>
                {getFormErrorMessage("student")} */}
                {/* </div> */}
                <div className="field checkbox">
                  <Controller
                      name="alumni"
                      control={control}
                      render={({ field }) => (
                          <Checkbox
                              className="checkbox_alumni"
                              id={field.name}
                              checked={field.value}
                              onChange={(e) => {
                                field.onChange(e.checked);
                                setValue("student", !e.checked);
                              }}
                          />
                      )}
                  />
                  <label htmlFor="alumni">Alumni</label>
                  {getFormErrorMessage("alumni")}
                </div>
              </div>
            </div>

            <div className="ask_connexion_name">
              <div className="field">
                <h2>{t("createAccount.nom")} *</h2>
                <Controller
                    name="lastName"
                    control={control}
                    rules={{ required: "Le nom est requis" }}
                    render={({ field, fieldState }) => (
                        <InputText
                            id={field.name}
                            placeholder="Dupont..."
                            {...field}
                            autoFocus
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                        />
                    )}
                />
                {getFormErrorMessage("lastName")}
              </div>
              <div className="field">
                <h2>{t("createAccount.prenom")} *</h2>
                <Controller
                    name="firstName"
                    control={control}
                    rules={{ required: "Le prénom est requis" }}
                    render={({ field, fieldState }) => (
                        <InputText
                            id={field.name}
                            {...field}
                            placeholder="Marie, Arthur..."
                            //   autoFocus
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                        />
                    )}
                />
                {getFormErrorMessage("firstName")}
              </div>
            </div>

            <div className="ask_connexion_country">
              <div className="field">
                <h2>{t("createAccount.date")} *</h2>
                <Controller
                    name="date"
                    control={control}
                    rules={{ required: "La date de naissance est requise" }}
                    render={({ field, fieldState }) => (
                        <Calendar
                            id={field.name}
                            {...field}
                            format="dd/MM/yyyy"
                            placeholder="11/02/1999"
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                        />
                    )}
                />
                {getFormErrorMessage("date")}
              </div>
              <div className="field" style={{ display: "none" }}>
                <h2 htmlFor="country">Pays</h2>
                <Controller
                    name="country"
                    control={control}
                    render={({ field }) => (
                        <Dropdown
                            id={field.name}
                            {...field}
                            value={country}
                            onChange={(e) => {
                              field.onChange(e.value);
                              setCountry(e.value);
                            }}
                            placeholder="France, Belgique..."
                            options={data}
                            className="box__input"
                        />
                    )}
                />
                {getFormErrorMessage("country")}
              </div>
            </div>

            <div className="ask_connexion_university">
              <div className="field">
                <h2>{t("createAccount.uni")}</h2>
                <Controller
                    name="universite"
                    control={control}
                    defaultValue={universitiesData.data?.find(u => u.name === "USPN")}
                    render={({ field }) => (
                        <Dropdown
                            id={field.name}
                            placeholder="Université..."
                            value={field.value}
                            options={universitiesData.data}
                            optionLabel="label"
                            disabled={true}
                            onChange={(e) => field.onChange(e.value)}
                        />
                    )}
                />
                {getFormErrorMessage("universite")}
              </div>
              <div className="field">
                <h2>{t("createAccount.promoDate")} *</h2>
                <Controller
                    name="anneeDiplome"
                    control={control}
                    rules={{ required: "L'année de diplôme est requise" }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={fr} rules={{ required: "L'année de diplôme est requise" }}>
                          <DatePicker
                              className="datepicker_create_account"
                              label="Année de diplôme"
                              views={["year"]}
                              value={value || null}
                              onChange={(date) => {
                                const formatted = date
                                    ? new Intl.DateTimeFormat("fr-FR", { year: "numeric" }).format(date)
                                    : null;
                                onChange(formatted);
                              }}
                              cancelLabel="Annuler"
                              error={!!error}
                              helperText={error?.message}
                          />
                        </MuiPickersUtilsProvider>
                    )}
                />
                {getFormErrorMessage("anneeDiplome")}
              </div>
            </div>

            <div className="field" style={{ display: "none" }}>
              <h2>{t("createAccount.promoNiv")}</h2>
              {niveauDiplomeData.loaded ? (
                  <Controller
                      name="niveauDiplome"
                      control={control}
                      render={({ field }) => (
                          <Dropdown
                              id={field.name}
                              placeholder="Bac, Bac+1, ..."
                              value={field.value}
                              options={niveauDiplomeData.data}
                              optionLabel="label"
                              onChange={(e) => field.onChange(e.value)}
                          />
                      )}
                  />
              ) : (
                  <Loader></Loader>
              )}

              {getFormErrorMessage("niveauDiplome")}
            </div>

            <div className="ask_connexion_coordinates">
              <div className="field">
                <h2>{t("createAccount.email")} *</h2>
                <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: "Email is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Invalid email address. E.g. example@email.com",
                      },
                    }}
                    render={({ field, fieldState }) => (
                        <InputText
                            id={field.name}
                            placeholder="hello123@gmail.com"
                            {...field}
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                        />
                    )}
                />
                {getFormErrorMessage("email")}
              </div>
              <div className="field">
                <h2>{t("createAccount.phone")}</h2>
                <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                        <InputMask
                            id={field.name}
                            mask={
                              country === "France"
                                  ? "+33 (0)9 99 99 99 99"
                                  : "+999 (9)9 99 99 99 99"
                            }
                            value={field.value}
                            placeholder={
                              country === "France"
                                  ? "+33 (0)9 99 99 99 99"
                                  : "+999 (9)9 99 99 99 99"
                            }
                            onChange={(e) => field.onChange(e.value)}
                        ></InputMask>
                    )}
                />

                {getFormErrorMessage("phone")}
              </div>
            </div>

            <div className="field">
              <h2>{t("createAccount.motivLabel")}</h2>
              <Controller
                  name="motivation"
                  control={control}
                  render={({ field, fieldState }) => (
                      <InputTextarea
                          id={field.name}
                          placeholder={t("createAccount.motivPlaceholder")}
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                      />
                  )}
              />
              {getFormErrorMessage("name")}
            </div>

          <div className="field">
              <h2>Composantes *</h2>
              <div className="column_line">
                  <Controller
                      name="components"
                      control={control}
                      rules={{
                          required: "Au moins une composante est requise",
                      }}
                      render={({ field, fieldState }) => (
                          <MultiSelect
                              {...field}
                              value={field.value}
                              options={componentsGroup}
                              optionLabel="componentLabel"
                              optionValue="componentCode"
                              placeholder="Sélectionner une ou plusieurs composantes"
                              display="chip"
                              showSelectAll={false}
                              filter
                              filterBy="componentLabel"
                              filterPlaceholder="Rechercher un composant"
                              className={classNames(
                                  { "p-invalid": fieldState.invalid },
                                  "input_actu"
                              )}
                              onChange={(e) => field.onChange(e.value)}
                          />
                      )}
                  />
                  {getFormErrorMessage("components")}
              </div>
          </div>

            <BtnBlanc btnTexte="Envoyer" />
          </form>
          {visibleModalCharte && (
              <ModalCharte
                  visibleModal={visibleModalCharte}
                  setVisibleModal={setvisibleModalCharte}
                  btnRefuse={() => {
                    props.setVisibleModal(false);
                  }}
                  btnAction={() => {
                    onSubmitCharte();
                  }}
              ></ModalCharte>
          )}
        </div>
      </div>
  );
};

CompteUniversite.propTypes = {
  title: PropTypes.string,
  chapeau: PropTypes.string,
  bouton: PropTypes.string,
  styleFormulaireMembre: PropTypes.bool,
  utilisateur: PropTypes.any,
  auth: PropTypes.object,
  universities: PropTypes.object,
  visibleModal: PropTypes.func,
  setVisibleModal: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  universities: state.universities,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CompteUniversite);
